import { isEmpty, readDictionary } from "@utils";

export default ({ route, store }) => {
	// Load the localstorage dictionary (if it exists) into the vuex store.
	const storageDictionary = readDictionary();
	if (!isEmpty(storageDictionary)) {
		store.commit("query/loadDictionary", storageDictionary);
	}
};
